import { colors } from 'component-library/styles/colors';
import React, { FC, SVGProps } from 'react';

interface TwitterProps extends SVGProps<SVGSVGElement> {
  backgroundColor?: string;
}

export const Twitter: FC<TwitterProps> = ({
  backgroundColor,
  fill,
  ...props
}) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={backgroundColor || '#26313B'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.8 17.7298C34.005 18.0912 33.1519 18.3363 32.2557 18.4457C33.1708 17.8835 33.8713 16.9917 34.2033 15.9324C33.3449 16.4531 32.3974 16.8311 31.3877 17.0361C30.5793 16.1512 29.4293 15.6001 28.1537 15.6001C25.7067 15.6001 23.7225 17.6356 23.7225 20.1448C23.7225 20.5006 23.7617 20.8482 23.8373 21.1805C20.1552 20.9908 16.8901 19.181 14.7049 16.4309C14.3229 17.1011 14.1056 17.8821 14.1056 18.7157C14.1056 20.2929 14.8885 21.6846 16.0763 22.4987C15.3501 22.4738 14.6671 22.2689 14.0692 21.9282V21.985C14.0692 24.1867 15.5971 26.0242 17.6231 26.4424C17.2519 26.5449 16.8605 26.6017 16.4555 26.6017C16.1694 26.6017 15.8927 26.5726 15.6214 26.5172C16.1856 28.3243 17.8215 29.6384 19.7597 29.6744C18.2439 30.893 16.3327 31.6172 14.2568 31.6172C13.8991 31.6172 13.5468 31.595 13.2 31.5549C15.1611 32.8468 17.4895 33.6001 19.9919 33.6001C28.143 33.6001 32.5985 26.6737 32.5985 20.6668L32.5837 20.0783C33.4543 19.4413 34.2074 18.6409 34.8 17.7298Z"
      fill={fill || colors.white}
    />
  </svg>
);
